<template>
  <div>
    <v-card class="mx-auto my-4" max-width="450">
      <v-card-title>
        <p class="text-h5">Almost there! Lets verify your email</p>
      </v-card-title>
      <v-card-text>
        <p class="text-h6">
          Check
          <span class="font-weight-bold">{{ $route.query.email }}</span> to
          verify your account and get started.
        </p>
        <!-- <v-btn>Resend email</v-btn> -->
        <div class="d-flex justify-space-between mt-4">
          <div>
            <span class=""> Need help? Check our </span>
            <a href="/support" class="text-decoration-none font-weight-light">
              support
            </a>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$utils.visit(this);
  },
};
</script>

<style></style>
